import { useQuery } from '@tanstack/react-query'

import { type InvoiceListParams, listInvoices } from './api'
import { INVOICES_KEY } from './keys'

export const INVOICES_DEFAULT_PAGE_SIZE = 10

export function useInvoices(params: InvoiceListParams) {
  return useQuery({
    queryKey: [...INVOICES_KEY, 'list', params],
    queryFn: ({ signal }) => listInvoices(params, signal)
  })
}
